/* Mack Weldon first-party tracking. Loaded deferred from the layout head.
   Depends on window.mw_uid / window.mw and window.__mwNativeFetch, set inline. */

// ── MW $ampEvent intercept — wraps window.amplitude so all $ampEvent calls
//    also fire to our first-party pipeline. Works whether Amplitude is present
//    or not. When Amplitude is removed, calls continue routing to MW pipeline.
    (function() {
      var ENDPOINT = 'https://jxusjowenwakfhtewhsd.supabase.co/functions/v1/track-event';
      // Native fetch, captured in <head> before anything can patch it (avoids tracking loops)
      var _fetch = window.__mwNativeFetch || window.fetch.bind(window);

      // ── Referrer capture (2026-08-07). Two views of arrival:
      //    - referrer: document.referrer for THIS pageview (internal for
      //      in-site navigation, external origin for cross-site — most
      //      referrers arrive origin-only under modern Referrer-Policy).
      //    - landing_referrer / landing_page: frozen at the FIRST pageview
      //      of the tab session, so the entry point survives internal
      //      navigation. Both attached to page_viewed events only.
      var _landing = null;
      try {
        var _lRaw = sessionStorage.getItem('mw_landing_ref');
        if (_lRaw === null) {
          _landing = { r: document.referrer || '', p: location.pathname + location.search };
          sessionStorage.setItem('mw_landing_ref', JSON.stringify(_landing));
        } else {
          _landing = JSON.parse(_lRaw);
        }
      } catch (e) { _landing = { r: '', p: '' }; }
      // Shared with the direct-events sender (separate IIFE below).
      window.__mwLanding = _landing;

      function mwTrack(eventName, properties) {
        try {
          var uid = window.mw_uid || (window.mw && window.mw.uid);
          if (!uid) return;

          var w = window.innerWidth;
          var device = w <= 768 ? 'mobile' : w <= 1024 ? 'tablet' : 'desktop';

          // Read active Convert experiment — structure: convert.currentData.experiences[expId].variation
          var expId = undefined;
          var varName = undefined;
          try {
            var cd = window.convert && window.convert.currentData;
            if (cd && cd.experiences) {
              var expIds = Object.keys(cd.experiences);
              if (expIds.length > 0) {
                expId = expIds[0];
                var variation = cd.experiences[expId].variation;
                varName = variation ? variation.name : undefined;
              }
            }
          } catch(e) {}

          var payload = {
            event_id:       uid + '_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
            mw_uid:         uid,
            customer_id:    window.mw && window.mw.customerId ? String(window.mw.customerId) : undefined,
            customer_email: window.mw && window.mw.customerEmail ? window.mw.customerEmail : undefined,
            event_name:     eventName.toLowerCase().replace(/\s+/g, '_'),
            page_url:       window.location.href,
            page_type:      (function() {
              var p = window.location.pathname;
              if (p === '/') return 'home';
              if (p.indexOf('/products/') === 0) return 'product';
              if (p.indexOf('/collections/') === 0) return 'collection';
              if (p.indexOf('/cart') === 0) return 'cart';
              if (p.indexOf('/search') === 0) return 'search';
              if (p.indexOf('/pages/') === 0) return 'page';
              if (p.indexOf('/blogs/') === 0) return 'blog';
              if (p.indexOf('/account') === 0) return 'account';
              return 'other';
            })(),
            device_type:    device,
            experiment_id:  expId,
            variation_name: varName,
            properties:     Object.assign({}, properties, { device: device }),
            // Session-stable landing referrer, top-level: the edge function
            // maps body.referrer -> the analytics_events.referrer column, and
            // the sessions rollup takes the first NON-NULL per session — a
            // per-page document.referrer would leak internal URLs into that
            // column on direct entries, so the column always gets the entry
            // referrer ('' -> null at the edge fn keeps direct as null).
            referrer:       _landing ? _landing.r : '',
            ts:             new Date().toISOString(),
          };

          if (payload.event_name === 'page_viewed') {
            // Per-page raw referrer for path analysis (internal for in-site
            // navigation), plus the frozen session entry point.
            payload.properties.referrer = document.referrer || '';
            payload.properties.landing_referrer = _landing ? _landing.r : '';
            payload.properties.landing_page = _landing ? _landing.p : '';
          }

          // Fire-and-forget: network failures (ad-blockers, offline) fail silently
          _fetch(ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            keepalive: true,
            credentials: 'omit',
          }).catch(function() {});

          // Identity stitching — once per session for logged-in customers only
          if (window.mw && window.mw.customerId) {
            var _identifyKey = 'mw_id_' + String(window.mw.customerId);
            if (!sessionStorage.getItem(_identifyKey)) {
              sessionStorage.setItem(_identifyKey, '1');
              _fetch('https://jxusjowenwakfhtewhsd.supabase.co/functions/v1/identify', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  mw_uid:         uid,
                  customer_id:    String(window.mw.customerId),
                  customer_email: window.mw.customerEmail || undefined,
                }),
                keepalive: true,
                credentials: 'omit',
              }).catch(function() {});
            }
          }
        } catch(e) {}
      }

      function makeProxy(real) {
        return new Proxy(real || {}, {
          get: function(target, prop) {
            if (prop === 'track') {
              return function(eventName, properties) {
                if (_inTrack) return;
                _inTrack = true;
                try {
                  mwTrack(eventName, properties);
                  if (real && typeof real.track === 'function') {
                    real.track.call(real, eventName, properties);
                  }
                } finally {
                  _inTrack = false;
                }
              };
            }
            if (prop === 'getSessionId') {
              return function() { return window.mw_uid || ''; };
            }
            var val = real ? real[prop] : target[prop];
            return typeof val === 'function' ? val.bind(real || target) : val;
          }
        });
      }

      var _real = null;
      var _inTrack = false;
      var _proxy = makeProxy(null);

      // Use defineProperty so our setter intercepts when the deferred webpack bundle
      // assigns window.amplitude — the simple var _real = window.amplitude approach
      // would be overwritten before any user interaction occurs.
      Object.defineProperty(window, 'amplitude', {
        configurable: true,
        get: function() { return _proxy; },
        set: function(v) {
          _real = v;
          _proxy = makeProxy(v);
        }
      });

      // Proactive identity stitch on page load — fires once per session for logged-in customers
      (function() {
        var uid = window.mw_uid || (window.mw && window.mw.uid);
        var cid = window.mw && window.mw.customerId;
        if (!uid || !cid) return;
        var key = 'mw_id_' + String(cid);
        if (sessionStorage.getItem(key)) return;
        sessionStorage.setItem(key, '1');
        _fetch('https://jxusjowenwakfhtewhsd.supabase.co/functions/v1/identify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            mw_uid:         uid,
            customer_id:    String(cid),
            customer_email: (window.mw && window.mw.customerEmail) || undefined,
          }),
          keepalive: true,
          credentials: 'omit',
        }).catch(function() {});
      })();

      // Persist UTM params to a 30-day cookie so the Web Pixel can read them at checkout
      // (Web Pixel sandbox can read cookies via browser.cookie.get but cannot set them)
      (function() {
        try {
          var search = window.location.search;
          if (!search) return;
          var p = new URLSearchParams(search);
          var src = p.get('utm_source');
          if (!src) return;
          var utmData = JSON.stringify({
            utm_source:   src,
            utm_medium:   p.get('utm_medium')   || '',
            utm_campaign: p.get('utm_campaign') || '',
            utm_content:  p.get('utm_content')  || '',
          });
          var expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
          document.cookie = 'mw_utm=' + encodeURIComponent(utmData) + '; expires=' + expires + '; path=/; SameSite=Lax';
        } catch(e) {}
      })();
    })();

// ── MW Behavioral Engagement Tracking
    (function() {
      var ENDPOINT = 'https://jxusjowenwakfhtewhsd.supabase.co/functions/v1/track-event';

      // Beacon dispatch is deferred to idle time so the network call never
      // runs inside an interaction's latency window (audit C6). Payloads are
      // built synchronously at event time; only the fetch waits. The queue
      // drains synchronously when the page hides (keepalive fetches survive
      // unload; an idle callback would never get the chance to run).
      var _mwQueue = [];
      var _mwFlushScheduled = false;

      function _mwDispatch(body) {
        try {
          fetch(ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: body,
            keepalive: true,
            credentials: 'omit',
          }).catch(function() {});
        } catch(e) {}
      }

      function _mwFlushQueue() {
        _mwFlushScheduled = false;
        while (_mwQueue.length) _mwDispatch(_mwQueue.shift());
      }

      function _mwScheduleFlush() {
        if (_mwFlushScheduled) return;
        _mwFlushScheduled = true;
        if (window.requestIdleCallback) {
          requestIdleCallback(_mwFlushQueue, { timeout: 2000 });
        } else {
          setTimeout(_mwFlushQueue, 250);
        }
      }

      window.addEventListener('pagehide', _mwFlushQueue);
      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'hidden') _mwFlushQueue();
      });

      function _mwSend(eventName, properties, topLevel) {
        try {
          var uid = window.mw_uid || (window.mw && window.mw.uid);
          if (!uid) return;
          var w = window.innerWidth;
          var _body = JSON.stringify(Object.assign({
              event_id:    uid + '_' + eventName + '_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6),
              mw_uid:      uid,
              customer_id: window.mw && window.mw.customerId ? String(window.mw.customerId) : undefined,
              event_name:  eventName,
              page_url:    window.location.href,
              page_type:   (function() {
                var p = window.location.pathname;
                if (p === '/') return 'home';
                if (p.indexOf('/products/') === 0) return 'product';
                if (p.indexOf('/collections/') === 0) return 'collection';
                if (p.indexOf('/cart') === 0) return 'cart';
                if (p.indexOf('/search') === 0) return 'search';
                if (p.indexOf('/pages/') === 0) return 'page';
                if (p.indexOf('/blogs/') === 0) return 'blog';
                if (p.indexOf('/account') === 0) return 'account';
                return 'other';
              })(),
              device_type: w <= 768 ? 'mobile' : w <= 1024 ? 'tablet' : 'desktop',
              properties:  properties || {},
              referrer:    (window.__mwLanding && window.__mwLanding.r) || undefined,
              ts:          new Date().toISOString(),
          }, topLevel || {}));
          // Page already hidden (e.g. page_exit from pagehide): an idle
          // callback would never run — dispatch immediately.
          if (document.visibilityState === 'hidden') {
            _mwDispatch(_body);
            return;
          }
          _mwQueue.push(_body);
          _mwScheduleFlush();
        } catch(e) {}
      }

      // Upsell A/B test tagging: the experiment_id/variation_name pair the
      // Convert-sourced mwTrack path above already writes at the top level.
      // Returns {} when no experiment is running, so non-experiment traffic
      // stays null and MackOS's experiment_id filter ignores it.
      //
      // Deliberately written BOTH as top-level keys and into properties. The
      // top-level pair lands in the analytics_events columns of the same name;
      // the properties copy is the safety net, because an edge function that
      // drops unrecognised top-level keys would otherwise make every event
      // unattributable and the whole experiment unmeasurable. Duplication is
      // cheap; a silent total loss of attribution is not.
      function _mwAbTags() {
        try {
          var ab = window.mw && window.mw.ab;
          if (!ab || !ab.experimentId || !ab.variant) return {};
          return { experiment_id: ab.experimentId, variation_name: ab.variant };
        } catch(e) { return {}; }
      }

      // ── 0. FIRST-PARTY PAGE VIEW (2026-08-09) ────────────────────────────────
      // Historically page_viewed came only from the Shopify Web Pixel, which
      // boots late — on bounce-heavy paid traffic ~half of real visitors never
      // got one (Aug-8 college LP investigation: users with scroll/exit events
      // but no page_viewed), and landing attribution keys off this event.
      // Fired here at script eval instead, marked src:'theme'. The pixel's
      // copy is scoped to checkout pages only (where theme JS can't run) in
      // the same rollout — see the pixel code in admin Customer events.
      (function() {
        try {
          var topLevel = {};
          try {
            var q = new URLSearchParams(window.location.search);
            ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function(k) {
              var v = q.get(k);
              if (v) topLevel[k] = v;
            });
          } catch(e) {}
          var landing = window.__mwLanding || { r: '', p: '' };
          _mwSend('page_viewed', {
            src: 'theme',
            referrer: document.referrer || '',
            landing_referrer: landing.r,
            landing_page: landing.p,
          }, topLevel);
        } catch(e) {}
      })();

      // ── 1. SCROLL DEPTH ──────────────────────────────────────────────────────
      (function() {
        var thresholds = [25, 50, 75, 100];
        var fired = {};
        var pageHandle = (function() {
          var p = window.location.pathname;
          if (p.indexOf('/products/') === 0) return p.split('/products/')[1].split('?')[0];
          if (p.indexOf('/collections/') === 0) return p.split('/collections/')[1].split('?')[0];
          return null;
        })();

        function checkScroll() {
          var scrolled = window.scrollY + window.innerHeight;
          var total = document.documentElement.scrollHeight;
          if (total <= window.innerHeight) return;
          var pct = Math.round((scrolled / total) * 100);
          thresholds.forEach(function(t) {
            if (pct >= t && !fired[t]) {
              fired[t] = true;
              _mwSend('scroll_depth', { scroll_pct: t, page_handle: pageHandle });
            }
          });
        }

        window.addEventListener('scroll', checkScroll, { passive: true });
        checkScroll();
      })();


      // ── 2. TIME ON PAGE / PAGE EXIT ──────────────────────────────────────────
      (function() {
        var pageStart = Date.now();
        var hiddenStart = null;
        var totalHidden = 0;
        var fired = false;
        var _maxScroll = 0;

        window.addEventListener('scroll', function() {
          var scrolled = window.scrollY + window.innerHeight;
          var total = document.documentElement.scrollHeight;
          if (total > window.innerHeight) {
            var pct = Math.round((scrolled / total) * 100);
            if (pct > _maxScroll) _maxScroll = pct;
          }
        }, { passive: true });

        document.addEventListener('visibilitychange', function() {
          if (document.visibilityState === 'hidden') {
            hiddenStart = Date.now();
            if (!fired) {
              fired = true;
              var foreground = Math.round((Date.now() - pageStart - totalHidden) / 1000);
              _mwSend('page_exit', {
                time_on_page_s:  foreground,
                total_elapsed_s: Math.round((Date.now() - pageStart) / 1000),
                max_scroll_pct:  _maxScroll,
              });
            }
          } else {
            if (hiddenStart) { totalHidden += Date.now() - hiddenStart; hiddenStart = null; }
            fired = false;
            pageStart = Date.now();
            totalHidden = 0;
          }
        });

        window.addEventListener('pagehide', function() {
          if (!fired) {
            fired = true;
            var foreground = Math.round((Date.now() - pageStart - totalHidden) / 1000);
            _mwSend('page_exit', {
              time_on_page_s:  foreground,
              total_elapsed_s: Math.round((Date.now() - pageStart) / 1000),
              max_scroll_pct:  _maxScroll,
            });
          }
        });
      })();


      // ── 3. RAGE CLICKS ───────────────────────────────────────────────────────
      (function() {
        var clicks = [];
        var WINDOW_MS = 600;
        var RADIUS_PX = 50;
        var THRESHOLD = 3;

        document.addEventListener('click', function(e) {
          var now = Date.now();
          clicks = clicks.filter(function(c) { return now - c.t < WINDOW_MS; });
          clicks.push({ t: now, x: e.clientX, y: e.clientY });

          if (clicks.length >= THRESHOLD) {
            var first = clicks[0];
            var allClose = clicks.every(function(c) {
              return Math.sqrt(Math.pow(c.x - first.x, 2) + Math.pow(c.y - first.y, 2)) < RADIUS_PX;
            });
            if (allClose) {
              var el = e.target;
              _mwSend('rage_click', {
                element_tag:     el.tagName.toLowerCase(),
                element_classes: el.className && typeof el.className === 'string'
                                   ? el.className.split(' ').slice(0, 3).join(' ') : '',
                element_text:    el.innerText ? el.innerText.trim().substring(0, 50) : '',
                click_count:     clicks.length,
                x:               Math.round(first.x),
                y:               Math.round(first.y),
              });
              clicks = [];
            }
          }
        });
      })();


      // ── 4. DEAD CLICKS ───────────────────────────────────────────────────────
      (function() {
        var lastFired = {};
        var THROTTLE_MS = 5000;

        document.addEventListener('click', function(e) {
          var el = e.target;
          var interactive = el.closest('a, button, [role="button"], input, select, textarea, label, [tabindex], [onclick], summary');
          if (interactive) return;

          var tag = el.tagName.toLowerCase();
          if (tag === 'body' || tag === 'html') return;

          var key = tag + ':' + (el.className || '').toString().substring(0, 30);
          var now = Date.now();
          if (lastFired[key] && now - lastFired[key] < THROTTLE_MS) return;
          lastFired[key] = now;

          _mwSend('dead_click', {
            element_tag:     tag,
            element_classes: el.className && typeof el.className === 'string'
                               ? el.className.split(' ').slice(0, 3).join(' ') : '',
            element_text:    el.innerText ? el.innerText.trim().substring(0, 50) : '',
            x:               Math.round(e.clientX),
            y:               Math.round(e.clientY),
          });
        });
      })();


      // ── 5. ELEMENT CLICK TRACKING ────────────────────────────────────────────
      (function() {
        var TRACKED_ELEMENTS = [
          // PDP engagement
          { selector: '.ProductGallery__image, .ProductGallery__mobileSwiperImage',                    name: 'pdp_image_click' },
          { selector: '.sizeSwatch__sizingGuideButton',                                                 name: 'size_chart_open' },
          { selector: '.productHero__reviews-link, .productHero__reviews-rating',                      name: 'reviews_section_click' },
          { selector: '.PDPInfoAccordions__item-header',                                                name: 'accordion_expand' },
          // notInDialog: the quick-add drawer is ProductHero-based and reuses
          // this class — drawer adds are module/addon events, not PDP ATCs
          { selector: '.productHero__addButton',                                                        name: 'pdp_atc_click', notInDialog: true },
          { selector: '.pdpTabs__tab',                                                                  name: 'pdp_tab_switch' },
          { selector: '.sizeSwatch__option--disabled',                                                  name: 'pdp_unavailable_variant_click' },
          { selector: '.ProductGallery__videoControl:not(.ProductGallery__videoControl--pauseButton)',  name: 'pdp_video_play' },
          { selector: '.js-shipping-trigger',                                                           name: 'pdp_shipping_tooltip_open' },
          { selector: '.js-returns-trigger',                                                            name: 'pdp_returns_tooltip_open' },
          { selector: '.js-tog-trigger',                                                                name: 'pdp_tog_open' },
          // Cart
          { selector: '.line-item__actionRemove',                                                     name: 'cart_item_removed' },
          // Navigation & discovery
          { selector: '.header__mainnav-nav-list-link',                                                 name: 'nav_click' },
          { selector: '.breadcrumbs a',                                                                  name: 'breadcrumb_click' },
          { selector: '.product-card__productBadge',                                                    name: 'badge_click' },
          // Search & cart header
          { selector: '.header__secondary-nav-link.--search',                                           name: 'search_open' },
          { selector: '.header__secondary-nav-link.--cart',                                             name: 'cart_open' },
          // Collection
          { selector: '.js-page-link',                                                                   name: 'collection_page_turn' },
          // Site-wide
          { selector: '#shopify-section-announcement-bar a',                                            name: 'announcement_bar_click' },
          { selector: '#shopify-section-footer a',                                                      name: 'footer_link_click' },
          // Banner / hero section CTAs (a.cta = link CTAs from cta snippet, excludes button.cta ATC elements)
          { selector: 'a.cta',                                                                          name: 'banner_cta_click' },
        ];

        // One ancestor walk decides whether ANY tracked selector matched —
        // template-gating this list is not safe (the quick-add drawer mounts
        // ProductHero markup on every page, so "PDP" selectors are reachable
        // sitewide by design), but most taps match nothing, and without this
        // guard every tap paid for ~24 separate closest() walks (audit C6).
        var COMBINED_SELECTOR = TRACKED_ELEMENTS.map(function(t) { return t.selector; }).join(', ');

        document.addEventListener('click', function(e) {
          try {
            if (e.target.closest && !e.target.closest(COMBINED_SELECTOR)) return;
          } catch (err) { /* fall through to the per-entry loop */ }
          TRACKED_ELEMENTS.forEach(function(tracked) {
            try {
              var el = e.target.closest(tracked.selector);
              if (!el) return;
              if (tracked.notInDialog && el.closest('dialog')) return;
              _mwSend(tracked.name, {
                element_text: el.innerText ? el.innerText.trim().substring(0, 80) : '',
                href:         el.href || undefined,
                page_handle:  (function() {
                  var p = window.location.pathname;
                  if (p.indexOf('/products/') === 0) return p.split('/products/')[1].split('?')[0];
                  if (p.indexOf('/collections/') === 0) return p.split('/collections/')[1].split('?')[0];
                  return undefined;
                })(),
              });
            } catch(err) {}
          });
        }, { passive: true });
      })();


      // ── 6. WISHLIST ADD ──────────────────────────────────────────────────────
      (function() {
        // capture: true bypasses Rivo's stopPropagation in the bubble phase
        document.addEventListener('click', function(e) {
          try {
            var btn = e.target.closest('rivo-favorite-button');
            if (!btn) return;
            // rivo-favorite-active is present when already favorited; absent = ADD action
            if (btn.classList.contains('rivo-favorite-active')) return;
            var productId = btn.getAttribute('data-product-id') || '';
            var productHandle = '';
            var productTitle = '';
            var card = btn.closest('.product-card');
            if (card) {
              var link = card.querySelector('a[href*="/products/"]');
              if (link) { var m = link.href.match(/\/products\/([^?#\/]+)/); if (m) productHandle = m[1]; }
              var titleEl = card.querySelector('[class*="productTitle"], [class*="product-card__title"]');
              if (titleEl) productTitle = titleEl.innerText.trim().substring(0, 80);
            } else {
              // PDP context: get handle from URL, title from page
              var pdpMatch = window.location.pathname.match(/\/products\/([^?#\/]+)/);
              if (pdpMatch) productHandle = pdpMatch[1];
              var pdpTitle = document.querySelector('.productInfo__title, h1.productHero__title');
              if (pdpTitle) productTitle = pdpTitle.innerText.trim().substring(0, 80);
            }
            _mwSend('wishlist_add', { product_id: productId, product_handle: productHandle, product_title: productTitle });
          } catch(err) {}
        }, true);
      })();


      // ── 7. PDP SELECTION ERROR ───────────────────────────────────────────────
      (function() {
        if (window.location.pathname.indexOf('/products/') !== 0) return;
        var lastFired = 0;
        // Button is disabled when no size selected; fire on the parent div click instead
        document.addEventListener('click', function(e) {
          try {
            var buy = e.target.closest('.productHero__buy');
            if (!buy) return;
            // the quick-add drawer reuses ProductHero markup — its buy area is
            // not a PDP selection error, and reading the page's FIRST
            // addButton (the main hero's) produced phantom errors on drawer adds
            if (buy.closest('dialog')) return;
            var btn = buy.querySelector('.productHero__addButton');
            if (!btn) return;
            if ((btn.innerText || '').trim().toUpperCase() !== 'SELECT A SIZE') return;
            var now = Date.now();
            if (now - lastFired < 2000) return;
            lastFired = now;
            _mwSend('pdp_selection_error', {
              page_handle: window.location.pathname.split('/products/')[1].split('?')[0]
            });
          } catch(err) {}
        }, { passive: true });
      })();


      // ── 8. NEWSLETTER SIGNUP ─────────────────────────────────────────────────
      (function() {
        window.addEventListener('klaviyoForms', function(e) {
          try {
            if (e.detail && e.detail.type === 'submit') {
              _mwSend('newsletter_signup', { form_id: e.detail.formId || '' });
            }
          } catch(err) {}
        });
      })();


      // ── 9. COLLECTION FILTER + SORT ──────────────────────────────────────────
      (function() {
        document.addEventListener('change', function(e) {
          try {
            var el = e.target;
            // Filter checkboxes (both non-Alpine js-facet-checkbox and Alpine version share this class)
            if (el.classList.contains('products-browser-facet-list__input')) {
              var filterType = el.getAttribute('data-key') || '';
              if (!filterType) {
                var fieldset = el.closest('fieldset');
                if (fieldset) {
                  var heading = fieldset.querySelector('.products-browser-facet__button-label');
                  if (heading) filterType = heading.innerText.trim();
                }
              }
              var filterValue = el.getAttribute('data-value') || el.value || '';
              if (!filterValue) {
                var lbl = el.closest('label');
                if (lbl) {
                  var labelText = lbl.querySelector('.products-browser-facet-list__label-text');
                  if (labelText) filterValue = labelText.innerText.trim();
                }
              }
              _mwSend('collection_filter_applied', {
                filter_type:   filterType,
                filter_value:  filterValue,
                filter_active: el.checked,
              });
              return;
            }
            // Sort radios
            if (el.classList.contains('js-sort-by')) {
              var sortValue = el.value || '';
              var sortLabel = '';
              var sortLbl = el.closest('label');
              if (sortLbl) {
                var sortSpan = sortLbl.querySelector('.products-browser-sort__option-label');
                if (sortSpan) sortLabel = sortSpan.innerText.trim();
              }
              _mwSend('collection_sort_changed', { sort_value: sortValue, sort_label: sortLabel });
            }
          } catch(err) {}
        }, { passive: true });
      })();


      // ── 11. CART QUANTITY CHANGED ─────────────────────────────────────────────
      (function() {
        document.addEventListener('click', function(e) {
          try {
            var btn = e.target.closest('.quantity-selector__button--increment, .quantity-selector__button--decrement');
            if (!btn) return;
            var direction = btn.classList.contains('quantity-selector__button--increment') ? 'increase' : 'decrease';
            _mwSend('cart_quantity_changed', { direction: direction });
          } catch(err) {}
        }, { passive: true });
      })();


      // ── 12. PDP IMAGE VIEWED ──────────────────────────────────────────────────
      (function() {
        if (window.location.pathname.indexOf('/products/') !== 0) return;
        if (!window.IntersectionObserver) return;
        var fired = new WeakSet();
        var pageHandle = window.location.pathname.split('/products/')[1].split('?')[0];
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting || fired.has(entry.target)) return;
            fired.add(entry.target);
            try {
              var img = entry.target.querySelector('img') || entry.target;
              var src = img.src ? img.src.split('?')[0].split('/').pop() : '';
              _mwSend('pdp_image_viewed', { page_handle: pageHandle, image_src: src });
            } catch(e) {}
          });
        }, { threshold: 0.8 });
        function observeImages() {
          document.querySelectorAll('.ProductGallery__image, .ProductGallery__mobileSwiperImage').forEach(function(el) {
            observer.observe(el);
          });
        }
        // Defer DOM queries until body exists
        if (document.body) { observeImages(); }
        else { document.addEventListener('DOMContentLoaded', observeImages); }
      })();


      // ── 13. COLLECTION GRID VIEWED ────────────────────────────────────────────
      (function() {
        if (!window.IntersectionObserver) return;
        var fired = new WeakSet();
        var count = 0;
        var MAX = 12; // cap per page load to avoid overwhelming the pipeline
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting || fired.has(entry.target) || count >= MAX) return;
            fired.add(entry.target);
            count++;
            try {
              var card = entry.target;
              var link = card.querySelector('a[href*="/products/"]');
              var handle = '';
              if (link) { var m = link.href.match(/\/products\/([^?#\/]+)/); if (m) handle = m[1]; }
              var titleEl = card.querySelector('.product-card__title');
              var idEl = card.querySelector('[data-product-id]');
              _mwSend('collection_grid_viewed', {
                product_id:     idEl ? idEl.getAttribute('data-product-id') || '' : '',
                product_handle: handle,
                product_title:  titleEl ? titleEl.innerText.trim().substring(0, 80) : '',
              });
            } catch(e) {}
          });
        }, { threshold: 0.5 });
        function observeCards() {
          document.querySelectorAll('.product-card').forEach(function(card) { observer.observe(card); });
        }
        function initCardObserver() {
          observeCards();
          // Cards are only added/replaced dynamically inside the PLP/search
          // grids (filter/sort/pagination section swaps). Watching those
          // section wrappers instead of document.body keeps this observer
          // from running on every DOM mutation sitewide (audit C6). The
          // wrapper (not the grid itself) must be observed: the swap
          // replaces the grid element inside its shopify-section.
          var grids = document.querySelectorAll('.main-product-grid, .products-browser');
          if (!grids.length) return;
          var mo = new MutationObserver(function(muts) {
            muts.forEach(function(mut) {
              mut.addedNodes.forEach(function(node) {
                if (!node.querySelectorAll) return;
                if (node.matches && node.matches('.product-card')) observer.observe(node);
                else node.querySelectorAll('.product-card').forEach(function(card) { observer.observe(card); });
              });
            });
          });
          grids.forEach(function(grid) {
            var wrapper = (grid.closest && grid.closest('.shopify-section')) || grid.parentElement || grid;
            mo.observe(wrapper, { childList: true, subtree: true });
          });
        }
        // Defer DOM queries until body exists
        if (document.body) { initCardObserver(); }
        else { document.addEventListener('DOMContentLoaded', initCardObserver); }
      })();

      // Section 13 — PDP PURCHASE TYPE CHANGE
      // Alpine's Tabs component dispatches 'on-tab-change' with the new tab index as detail.
      // Only fires when the index actually changes (guard is in onSelect itself).
      document.addEventListener('on-tab-change', function(e) {
        try {
          var container = e.target && e.target.closest
            ? e.target.closest('.productHero__purchaseTypeToggleContainer')
            : null;
          if (!container) return;
          var tabIndex = typeof e.detail === 'number' ? e.detail : parseInt(e.detail, 10);
          var tabs = container.querySelectorAll('.productHero__purchaseTypeToggle');
          var tab = tabs[tabIndex];
          if (!tab) return;
          var type = 'unknown';
          tab.classList.forEach(function(cls) {
            var m = cls.match(/^productHero__purchaseTypeToggle--(?!active)(.+)$/);
            if (m) type = m[1];
          });
          var titleEl = tab.querySelector('span');
          var tabTitle = titleEl ? titleEl.innerText.trim() : '';
          var pageHandle = '';
          var pm = window.location.pathname.match(/\/products\/([^?#\/]+)/);
          if (pm) pageHandle = pm[1];
          _mwSend('pdp_purchase_type_change', { tab_type: type, tab_title: tabTitle, page_handle: pageHandle });
        } catch(err) {}
      });

      // Section 14 — EXIT INTENT (desktop only)
      (function() {
        if (window.innerWidth <= 768) return;
        var fired = false;
        var pageStart = Date.now();
        var maxScroll = 0;
        window.addEventListener('scroll', function() {
          var pct = Math.round((window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100);
          if (pct > maxScroll) maxScroll = pct;
        }, { passive: true });
        document.addEventListener('mouseleave', function(e) {
          if (e.clientY > 0 || fired) return;
          fired = true;
          setTimeout(function() { fired = false; }, 3000);
          _mwSend('exit_intent', {
            time_on_page_s: Math.round((Date.now() - pageStart) / 1000),
            max_scroll_pct: maxScroll,
          });
        });
      })();

      // Section 15 — CONTENT COPIED
      document.addEventListener('copy', function() {
        try {
          var sel = window.getSelection ? window.getSelection().toString() : '';
          if (!sel || sel.length < 3) return;
          _mwSend('content_copied', {
            copied_text: sel.substring(0, 100),
            element_tag: document.activeElement ? document.activeElement.tagName.toLowerCase() : '',
          });
        } catch(err) {}
      });

      // Section 16 — SEARCH ZERO RESULTS (component-driven, 2026-07-25)
      // The old MutationObserver on the .globalSearch panel had three data
      // corruptions (OS investigation, 9,373-event sample: only 18% fired
      // on /search): it tracked the sitewide predictive OVERLAY under the
      // name analysts read as "committed search returned nothing"; it read
      // the raw input value at panel-mount time (mid-typing fragments,
      // refires per panel toggle); and the overlay rendered its no-results
      // panel on failed/ABORTED fetches (navigating away mid-request), so
      // valid terms logged as zero-result searches from any page. The
      // components now dispatch semantic events exactly once per settled
      // state — split into two event names so the overlay and the results
      // page can't be conflated again:
      //   mw:predictive-zero-results  <- global-search.js (settled overlay
      //                                  query, zero predictive products)
      //   mw:search-zero-results      <- products-browser.js (/search page,
      //                                  committed unfiltered query, 0 total)
      window.addEventListener('mw:predictive-zero-results', function(e) {
        try {
          var d = e.detail || {};
          if (!d.search_term) return;
          _mwSend('predictive_zero_results', {
            search_term: d.search_term,
            suggestion_count: d.suggestion_count,
            full_search_count: d.full_search_count,
          });
        } catch(err) {}
      });
      window.addEventListener('mw:search-zero-results', function(e) {
        try {
          var d = e.detail || {};
          if (!d.search_term) return;
          _mwSend('search_zero_results', {
            search_term: d.search_term,
            result_count: 0,
          });
        } catch(err) {}
      });
      // Predictive overlay funnel (2026-07-25). Most successful searches
      // click straight from the overlay to a PDP and never reach /search,
      // so the term->product association was previously unrecorded and CTR
      // was uncomputable.
      //   predictive_search_performed   — DENOMINATOR: one per settled term
      //                                   the user stopped at (quiet-period
      //                                   scheduled; flushed by clicks and
      //                                   by closing the overlay)
      //   predictive_product_card_click — NUMERATOR: overlay card -> PDP,
      //                                   with position and counts
      //   predictive_search_click       — committed-to-/search outcomes
      //                                   (suggestion / view_all / submit)
      //   predictive_zero_results       — flagged failure subset (also
      //                                   counted in performed rows with
      //                                   result_count = 0)
      // CTR = product_card_click / search_performed. Idle-state clicks
      // carry no term and are dropped.
      window.addEventListener('mw:predictive-search-performed', function(e) {
        try {
          var d = e.detail || {};
          if (!d.search_term) return;
          _mwSend('predictive_search_performed', {
            search_term: d.search_term,
            result_count: d.result_count,
            shown_hits: d.shown_hits,
            suggestion_count: d.suggestion_count,
            matched_by: d.matched_by,
          });
        } catch(err) {}
      });
      window.addEventListener('mw:predictive-search-click', function(e) {
        try {
          var d = e.detail || {};
          if (!d.search_term) return;
          var isCard = d.destination === 'product';
          _mwSend(isCard ? 'predictive_product_card_click' : 'predictive_search_click', {
            search_term: d.search_term,
            destination: d.destination,
            product_handle: d.product_handle,
            suggestion_text: d.suggestion_text,
            position: d.position,
            result_count: d.result_count,
            shown_hits: d.shown_hits,
          });
        } catch(err) {}
      });

      // Section 17 — SEARCH ABANDONED
      (function() {
        // Component-driven (2026-07-25): the DOM listeners keyed on
        // .globalSearch__formInput/__formClose/__product — classes the
        // search redesign removed, which would have silently killed this
        // event. global-search.js closeSearch() dispatches with the live
        // partial term; committed paths (Enter, suggestion, product,
        // view-all) navigate without closing, preserving the old
        // "closed with text = abandoned" semantics exactly.
        window.addEventListener('mw:search-abandoned', function(e) {
          try {
            var d = e.detail || {};
            if (!d.partial_term) return;
            _mwSend('search_abandoned', { partial_term: d.partial_term });
          } catch(err) {}
        });
      })();

      // Section 18 — SEARCH REFINED (full-page /search only)
      (function() {
        if (window.location.pathname.indexOf('/search') !== 0) return;
        try {
          var params = new URLSearchParams(window.location.search);
          var currentTerm = (params.get('q') || '').trim();
          var lastTerm = sessionStorage.getItem('mw_last_search') || '';
          if (lastTerm && currentTerm && lastTerm.toLowerCase() !== currentTerm.toLowerCase()) {
            _mwSend('search_refined', { original_term: lastTerm, refined_term: currentTerm });
          }
          if (currentTerm) sessionStorage.setItem('mw_last_search', currentTerm);
        } catch(err) {}
      })();

      // -- Add-on-products ATC --
      (function() {
        var _mwAddOnCtx = null;
        var _mwPendingTitle = null;
        var _mwPendingPosition = null;
        var _mwFromAddonBtn = false;

        // Capture phase — grab title/position before Alpine handles the click.
        // Both the Add button and the item image open the quick-add drawer.
        document.addEventListener('click', function(e) {
          try {
            if (!e.target.closest('.add-on-products__item-media, .add-on-products__item-add')) return;
            var item = e.target.closest('.add-on-products__item');
            var titleEl = item && item.querySelector('.add-on-products__item-title');
            _mwPendingTitle = titleEl ? titleEl.textContent.trim() || null : null;
            _mwFromAddonBtn = !!e.target.closest('.add-on-products--pdp');
            if (item) {
              var siblings = item.parentElement.querySelectorAll('.add-on-products__item');
              _mwPendingPosition = Array.from(siblings).indexOf(item) + 1;
            }
          } catch(err) {}
        }, true);

        // Set context for any isUpsellProduct drawer open; source distinguishes PDP module vs cart quick add
        window.addEventListener('open-quick-add-drawer', function(e) {
          try {
            var detail = e.detail || {};
            var settings = (detail.productSettings || [])[0];
            if (!settings || !(settings.options || {}).isUpsellProduct) {
              _mwAddOnCtx = null;
              _mwPendingTitle = null;
              _mwPendingPosition = null;
              _mwFromAddonBtn = false;
              return;
            }
            _mwAddOnCtx = {
              addon_product_handle: settings.handle,
              addon_product_title: _mwPendingTitle || null,
              addon_position: _mwPendingPosition,
              source_page: window.location.pathname,
              source_product_handle: window.location.pathname.split('/products/')[1] || null,
              source: _mwFromAddonBtn ? 'pdp_addon' : 'cart_quick_add',
            };
            _mwPendingTitle = null;
            _mwPendingPosition = null;
            _mwFromAddonBtn = false;
          } catch(err) {}
        });

        // Don't check btn.disabled: handleAddToCart() disables it synchronously
        // before this bubble listener runs.
        document.addEventListener('click', function(e) {
          try {
            if (!_mwAddOnCtx) return;
            if (!e.target.closest('.quick-add-drawer__product-addButton')) return;
            _mwSend(
              'addon_add_to_cart',
              Object.assign({}, _mwAddOnCtx, _mwAbTags()),
              _mwAbTags()
            );
            _mwAddOnCtx = null;
          } catch(err) {}
        });
      })();

      // -- Upsell A/B exposure --
      // product-hero fires this the moment the Customers Also Like strip
      // actually renders, so a visitor who bounced before it appeared is not
      // counted as exposed. Assignment itself is decided in the head, so the
      // arm is already known here — no race with carousel render.
      window.addEventListener('mw:ab-exposure', function(e) {
        try {
          var d = e.detail || {};
          _mwSend('ab_exposure', Object.assign({
            variant: d.variant,
            fell_back: d.fell_back,
            product_handle: d.product_handle,
            surface: 'pdp_customers_also_like',
          }, _mwAbTags()), _mwAbTags());
        } catch(err) {}
      });

      // -- Module quick-add attribution (Shop the Look / Product Three Ways) --
      // Sections stamp data-mw-module on their wrapper; components pass it as
      // analyticsSource on 'open-quick-add-drawer'. Two ATC paths:
      //   drawer          — quick-add drawer dispatches 'mw:quick-add-atc'
      //                     with what was actually added; joined with the
      //                     source context captured at drawer open
      //   card_quick_add  — desktop hover size-panel adds straight to cart;
      //                     the card dispatches 'mw:module-atc' itself
      (function() {
        var _mwModuleCtx = null;

        window.addEventListener('open-quick-add-drawer', function(e) {
          try {
            var detail = e.detail || {};
            if (!detail.analyticsSource) {
              _mwModuleCtx = null;
              return;
            }
            var settings = detail.productSettings || [];
            _mwModuleCtx = {
              source: detail.analyticsSource,
              source_page: window.location.pathname,
              source_product_handle: window.location.pathname.split('/products/')[1] || null,
              product_count: settings.length,
              product_handle: settings.length === 1 ? settings[0].handle : null,
            };
            _mwSend('module_quick_add_open', _mwModuleCtx);
          } catch(err) {}
        });

        // Not cleared after send: the Shop the Look drawer holds several
        // products and each add is its own module_add_to_cart. Every drawer
        // open resets the context, so it can't leak across drawer sessions.
        window.addEventListener('mw:quick-add-atc', function(e) {
          try {
            if (!_mwModuleCtx) return;
            var d = e.detail || {};
            _mwSend('module_add_to_cart', {
              source: _mwModuleCtx.source,
              method: 'drawer',
              source_page: _mwModuleCtx.source_page,
              source_product_handle: _mwModuleCtx.source_product_handle,
              product_handle: d.product_handle || null,
              product_title: d.product_title || null,
              variant_id: d.variant_id || null,
              variant_options: d.options || null,
            });
          } catch(err) {}
        });

        window.addEventListener('mw:module-atc', function(e) {
          try {
            var d = e.detail || {};
            if (!d.source) return;
            _mwSend('module_add_to_cart', {
              source: d.source,
              method: 'card_quick_add',
              source_page: window.location.pathname,
              source_product_handle: window.location.pathname.split('/products/')[1] || null,
              product_handle: d.product_handle || null,
              product_title: d.product_title || null,
              variant_id: d.variant_id || null,
              variant_options: d.options || null,
            });
          } catch(err) {}
        });
      })();

      // -- Cross-product bundle builder (college LP looks; reusable) --
      // Sections dispatch 'mw:bundle-builder' with an action; event names
      // land as bundle_builder_open / bundle_builder_add_to_cart so the
      // funnel (opens -> adds) is queryable per look and per page.
      (function() {
        window.addEventListener('mw:bundle-builder', function(e) {
          try {
            var d = e.detail || {};
            if (!d.action || !d.source) return;
            _mwSend('bundle_builder_' + d.action, {
              source: d.source,
              source_page: window.location.pathname,
              look_title: d.look_title || null,
              bundle_id: d.bundle_id || null,
              variant_ids: d.variant_ids || null,
              product_titles: d.product_titles || null,
              subtotal_cents: (typeof d.subtotal === 'number') ? d.subtotal : null,
              total_cents: (typeof d.total === 'number') ? d.total : null,
              discount_pct: d.discount_pct || null,
            });
          } catch(err) {}
        });
      })();

    })();

// ── MW cart attribute fallback — writes mw_uid directly on cart events
    (function() {
      var _written = false;
      function writeMwUidToCart() {
        if (_written) return;
        var uid = window.mw_uid || (window.mw && window.mw.uid);
        if (!uid) return;
        _written = true;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { mw_uid: uid } })
        }).catch(function() { _written = false; });
      }
      window.addEventListener('open-cart', writeMwUidToCart);
      window.addEventListener('update-and-open-cart', writeMwUidToCart);
      window.addEventListener('tl:cart:open', writeMwUidToCart);
    })();
